{{ latestActivity ? (latestActivity | dateFormat | async) : '' }}